// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BxOHB","option":"styles_option__3t1h6","active":"styles_active__2ej89"};